/* eslint-disable func-names */
import EDC from '../../../shared/globals';

EDC.Animations.Question = function (scene) {
  this.scene = scene;
  this.questionMark = null;
  this.animConfig = {
    key: 'question-blinking',
    frames: this.scene.anims.generateFrameNumbers('question-mark', { start: 0, end: 2, first: 0 }),
    frameRate: 3,
    repeat: -1,
  };
};

EDC.Animations.Question.prototype.create = function (x, y) {
  this.scene.anims.create(this.animConfig);
  this.questionMark = this.scene.add.sprite(x, y, 'question-mark').play('question-blinking');
  this.questionMark.x += this.questionMark.width / 2;
};

EDC.Animations.Question.prototype.moveTo = function (newX, newY, isImmediate) {
  if (isImmediate) {
    this.questionMark.setPosition(newX, newY + this.questionMark.height / 2);
  } else {
    this.scene.tweens.add({
      targets: this.questionMark,
      x: newX,
      y: newY + this.questionMark.height / 2,
      duration: 180,
      ease: 'Linear',
    });
  }
};

EDC.Animations.Question.prototype.show = function () {
  this.questionMark.setAlpha(1);
};

EDC.Animations.Question.prototype.hide = function () {
  this.questionMark.setAlpha(0);
};

export default EDC.Animations.Question;
